import css from './numbers.module.scss';

import { memo, useEffect, useState } from 'react';

import { useStableCallback } from 'core/hooks/useStableCallback';

type Props = {
  onReplay: () => void;
  onAddSym: (num: string) => void;
  isEmpty: boolean;
  disabled: boolean;
};

const NumbersButtons = ({ onReplay, onAddSym, isEmpty, disabled }: Props) => {
  const [container, setContainer] = useState<HTMLElement | null>(null);
  const [size, setSize] = useState<number | null>(null);

  const reLayout = useStableCallback((): void => {
    if (!container) return;

    const rem = 16; // padding between buttons = 1rem = 16px
    const sizeByWidth = (container.offsetWidth - 2 * rem) / 3;
    const sizeByHeight = (container.offsetHeight - 3 * rem) / 4;
    const size = Math.min(sizeByWidth, sizeByHeight);
    setSize(Math.floor(size));
  });

  useEffect(() => {
    if (container) reLayout();
  }, [container]);

  useEffect(() => {
    window.addEventListener('resize', reLayout);
    return () => window.removeEventListener('resize', reLayout);
  });

  return (
    <div
      className={css.buttonsWrapper}
      ref={setContainer}
      style={{ ['--size' as string]: size && `${size}px` }}
    >
      <div className={css.buttons}>
        {BUTTONS.map(sym => (
          <button
            key={sym}
            className={css.buttonsButton}
            disabled={disabled || (sym === '.' && isEmpty)}
            data-sym={sym}
            onClick={() => (sym === REPLAY_SYM ? onReplay() : onAddSym(sym))}
          >
            {sym}
          </button>
        ))}
      </div>
    </div>
  );
};

export default memo(NumbersButtons);

const REPLAY_SYM = '🔊';
const BUTTONS = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '.',
  '0',
  REPLAY_SYM,
];
